import script from "./MenuListCom.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuListCom.vue?vue&type=script&setup=true&lang=js"

import "./MenuListCom.vue?vue&type=style&index=0&id=462ddd82&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462ddd82"]])

export default __exports__